export const USER_ROLES = {
  provider: 'provider',
  client: 'client',
  admin: 'admin',
};
